import { CreateSurgicalOrderStatus } from 'domain/usecases/surgical-order/create-surgical-order-status'
import { SurgicalOrderRepository } from 'repository/interfaces/surgical-order-repository'

export class RemoteCreateSurgicalOrderStatus
  implements CreateSurgicalOrderStatus
{
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  create(
    params: CreateSurgicalOrderStatus.Params
  ): Promise<CreateSurgicalOrderStatus.Model> {
    return this.surgicalOrderRepository.createSurgicalOrderStatus(params)
  }
}
